import React from "react";
import Vector2 from "../Assets/img/profile/Vector (2).png";
import Vector from "../Assets/img/profile/Vector.png";
import clock from "../Assets/img/profile/Group 116.png";
import cloud from "../Assets/img/profile/akar-icons_cloud-upload.png";
import discord from "../Assets/img/profile/Group 8184.png";
import styles from "../Assets/css/overview.module.css";

function Notifications(props) {
	let height = props.height;
	console.log(height);
	return (
		// <div style={{ position: "relative",margin:"auto" }}>
		<div
			style={{
				position: "absolute",
				// width: "150px",
				overflowY: "scroll",
				top: "0",
				bottom: "0",
				right: "0",
				height: "55vw",
				// width: "40%",
				boxSizing: "border-box",
				marginTop: "6%",
			}}
			className={`col-xl-3 col-lg-5 col-md-6 col-sm-6 ${styles.notification_div}`}
		>
			<h2 className={styles.notifications}>Notifications</h2>
			<h5 style={{ fontSize: "17px" }} className={styles.topic}>
				Introduction to Digital Medium & Tools
			</h5>
			<p className={styles.topic_text}>
				This is an introduction session about how to deal with the
				latest digital tools and understanding the digital relam
			</p>
			<div
				style={{ fontSize: "12px" }}
				className={`d-flex ${styles.chedule_div}`}
			>
				<div className={styles.date_div}>
					<img
						src={Vector}
						alt=""
						style={{ height: "80%" }}
						className={`img-fluid ${styles.calendar_img}`}
					/>
					27th June
				</div>
				<div className={styles.time_div}>
					<img
						style={{ height: "80%" }}
						src={clock}
						alt=""
						className={`img-fluid ${styles.clock_img}`}
					/>
					8AM-10AM
				</div>
			</div>

			<button type="submit" className={styles.join_btn}>
				JOIN
			</button>

			<hr className={styles.join_hr} />

			<div className={styles.lecture_card_1}>
				<div className="row">
					<div
						style={{ fontSize: "12px" }}
						className="col-xl-2 col-lg-2 col-md-3 col-sm-2 mx-3 mt-3 mb-0 col-2"
					>
						<p>
							{" "}
							<b>21st June</b>{" "}
						</p>
					</div>
					<div
						style={{ fontSize: "12px" }}
						className="col-xl-6 col-lg-6 col-md-5 col-sm-6 mt-3 mb-0 col-6"
					>
						<p>Introduction & Interest Note ClassName of Coding </p>
					</div>
					<div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 mt-3 mb-0 col-2">
						<span
							className={`material-icons ${styles.material_icons}`}
						>
							cloud_upload
						</span>
					</div>
				</div>
			</div>

			<div className={styles.lecture_card}>
				<div className="row">
					<div
						style={{ fontSize: "12px" }}
						className="col-xl-2 col-lg-2 col-md-3 col-sm-2 mx-3 mt-3 mb-0 col-2"
					>
						<p>
							{" "}
							<b> 27th June</b>
						</p>
					</div>
					<div
						style={{ fontSize: "12px" }}
						className="col-xl-6 col-lg-6 col-md-5 col-sm-6 mt-3 mb-0 col-6"
					>
						<p>Introduction & Interest Note ClassName of Coding </p>
					</div>
					<div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 mt-3 mb-0 col-2">
						<span
							className={`material-icons ${styles.material_icons}`}
						>
							cloud_done
						</span>
					</div>
				</div>
			</div>

			<div
				style={{ fontSize: "12px" }}
				className={`${styles.lecture_card} ${styles.text_card}`}
			>
				<div className="row">
					<div
						style={{ fontSize: "12px" }}
						className="col-xl-11 col-lg-11 col-md-11 col-sm-11 mx-3 mt-3 mb-0 col-11"
					>
						<p>
							Please upload all of your coding assignments by tmrw
						</p>
						<p className={styles.footer_text}>DSA . 27min ago</p>
					</div>
				</div>
			</div>

			<div className={styles.lecture_card}>
				<div className="row">
					<div
						style={{ fontSize: "12px" }}
						className="col-xl-2 col-lg-2 col-md-3 col-sm-2 mx-3 mt-3 mb-0 col-2"
					>
						<p>
							{" "}
							<b> 27th June</b>
						</p>
					</div>
					<div
						style={{ fontSize: "12px" }}
						className="col-xl-6 col-lg-6 col-md-5 col-sm-6 mt-3 mb-0 col-6"
					>
						<p>Introduction & Interest Note ClassName of Coding </p>
					</div>
				</div>
			</div>
			{/* Discord */}
			<div className={styles.discord}>
				<div style={{ display: "flex" }}>
					<div className={`d-flex ${styles.discord_div}`}>
						<div>
							<img
								src={discord}
								alt=""
								className={styles.discord_icon}
							/>
						</div>
					</div>
					<div style={{ paddingLeft: "2%" }}>
						<div style={{ margin: "0" }}>
							<p
								//  style={{ fontSize: "0.9vw" }}
								className={styles.discord_text}
							>
								Join our Discord group to get all your doubts
								clarified
							</p>
						</div>
						<button
							style={{ margin: "0" }}
							type="submit"
							className={styles.discord_btn}
						>
							Join now
						</button>
					</div>
				</div>
			</div>
			{/* </div> */}
		</div>
	);
}

export default Notifications;
